// extracted by mini-css-extract-plugin
export default {"container":"PaymentSuccess_container__nvmpk","success":"PaymentSuccess_success__Ithof","failed":"PaymentSuccess_failed__qo57f","button":"PaymentSuccess_button__OK2cn"};